export const ONLY_ALPHANUMERICS_WITH_SPACE = /^[a-zA-Z0-9 ]+$/
